<template lang="pug">
tr(
  data-test="results-row"
  :class="{ 'status-init': statusInit, 'loaded-not-seen': loadedNotSeen, 'loaded-seen': loadedSeen}"
  :style="{backgroundColor: colorStatus}"
).res-row
  td.text-center {{ positionInList }}
  td(data-test="result-datetime").time  {{ item.formattedDatetime }} 
    br 
    | {{ item.location | clipString(12) }}
  td.text-center
    v-checkbox(
      v-model="item.hasComeToCourse"
      :key="item.ID"
      @change="updateHasCome"
    ).justify-center
  td.name.text-center {{ item.candidate.name }}
  td.number {{ item.reservationCode }}
  td(:class="{'many-mistakes' : item.result && item.result.has_many_mistakes}").res-info
    result-info(v-if="!item.is_mijn_reservation" data-test="results-info" :statusInit="statusInit" :model="item" :loadedNotSeen="loadedNotSeen" :loadedSeen="loadedSeen")
    edit-result-info(v-if="item.is_mijn_reservation" data-test="edit-results-info" :statusInit="statusInit" :model="item" :loadedNotSeen="loadedNotSeen" :loadedSeen="loadedSeen")
  td.res-status
    v-chip(v-if="item.result" :color="statusChipColor" small dark) {{ item.result.status }}
    v-chip(v-else color="black" small dark) Not fetched
  td.app-id {{ item.applicationID }}
  td.type
    v-chip(small :color="PURPLE" v-if="item.is_mijn_reservation").text-bold.white--text Mijn
    v-chip(small color="amber lighten-1" v-else).text-bold.white--text Top
  td.product 
    v-chip(small color="amber lighten-1").text-bold.white--text {{ item.productName }}
  td.notes 
    notes(
      :value="item.notes" 
      :ID="item.ID"
      :service="svc"
    )

</template>

<script>
import { RESULT_STATUS } from '../core/models/resultReservedExam'
import { COLOR_STATUS, PURPLE } from '@/app/admin/modules/results/core/results-const'
import Notes from "@/app/admin/modules/candidates/components/candidates/CandidatesNote.vue"

export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    index: Number,
    primaryPagination: Object
  },

  inject: ['svc'],

  data: () => ({
    PURPLE,
    RESULT_STATUS: RESULT_STATUS
  }),

  computed: {
    positionInList() {
      return (this.index + 1) + (this.primaryPagination.page - 1) * this.primaryPagination.size;
    },
    statusInit() {
      if(!this.item.result || this.item.result.status !== RESULT_STATUS.LOADED) return true
      return false
    },

    failed() {
      if(this.item.result && this.item.result.status === RESULT_STATUS.FAILED) return true
      return false
    },

    loadedNotSeen() {
      if(!this.item.result) return false
      if(this.item.result.status === RESULT_STATUS.LOADED && !this.item.result.seen) return true
      return false
    },

    loadedSeen() {
      if(!this.item.result) return false
      if(this.item.result.status === RESULT_STATUS.LOADED && this.item.result.seen) return true
      return false
    },

    colorStatus() {
      if(!this.loadedSeen) return null
      if(this.item.result.hasZeroMistakes) return COLOR_STATUS.ZERO_MISTAKES
      if(this.item.result.hasPassed) return COLOR_STATUS.HAS_PASSED
      if(this.item.result.notCame) return COLOR_STATUS.HAS_NOT_CAME
      if(!this.item.result.hasPassed) return COLOR_STATUS.NOT_HAS_PASSED
      return null
    },

    statusChipColor() {
      if(!this.item.result) return 'black'
      if(this.item.result.status === RESULT_STATUS.LOADED) return 'success'
      if(this.item.result.status === RESULT_STATUS.FAILED) return 'error'
      if(this.item.result.status === RESULT_STATUS.FETCHING) return 'warning'
      return 'black'
    },

  },

  methods: {
    async updateHasCome(val) {
      try {
        this.loading = true
        await this.svc.updateHasComeToCourse(this.item.ID, val)
        this.$notify({type: 'success', text: 'Updated'})

      } catch (error) {
        console.log('error')
      }
      finally {
        this.loading = false
      }
      
    },
  },
  
  components: {
    resultInfo: () => import ("./ResultsInfo.vue"),
    editResultInfo: () => import ("./EditResultsInfo.vue"),
    hasComeToCourse: () => import('./ResultsHasCome.vue'),
    Notes
  }
}
</script>

<style lang="scss" scoped>
.res-row {
  transition: background-color .3s;
}
.loaded-not-seen {
  background-color: #ccc;
}
.time {
  width: 10%;
  text-align: center;
}
.app-id {
  width: 10%;
  text-align: center;
}
.number {
  width: 10%;
  text-align: center;
}
.product {
  width: 10%;
  text-align: center;
}

.type{
  text-align: center;
}

.res-info {
  width: 10%;
  text-align: center;
}
.res-status {
  width: 10%;
  text-align: center;
}
.name {
  min-width: 20%;
  width: 20%;
}

.notes {
  max-width: 100px;
}

.many-mistakes {
  background-color: $BLM;
}

.note {
      overflow: hidden;
    max-height: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    margin-bottom: 0;
    max-width: 150px;
}

</style>